import { useTranslation } from 'react-i18next';

import DeleteMenuIcon from '@crm/shared/assets/icons/delete.svg?react';
import EditMenuIcon from '@crm/shared/assets/icons/edit.svg?react';
import DotsMenuIcon from '@crm/shared/assets/icons/ellipsis-vertical.svg?react';
import {
    Button,
    DropdownMenuTrigger,
    DropdownMenu,
    SvgIcon,
    DropdownMenuItem,
    DropdownMenuContent,
} from '@crm/shared/ui';

export const ColumnDropdownMenu = ({
    onEditMode,
    onDelete,
}: {
    onEditMode: () => void;
    onDelete: () => void;
}) => {
    const { t } = useTranslation();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                render={
                    <Button
                        aria-label={t('crm.deals.board.column.menu.ariaLabel')}
                        className="hover-bg-transparent size-5 rounded-sm text-smtr-main-tertiary-100 hover:bg-smtr-main-gray-200"
                        size="icon-sm"
                        variant="link"
                    >
                        <SvgIcon icon={DotsMenuIcon} />
                    </Button>
                }
            />
            <DropdownMenuContent align="start" className="flex w-fit flex-col gap-2 px-3 py-2">
                <DropdownMenuItem
                    className="p-0 text-xs text-primary hover:bg-transparent focus:bg-transparent"
                    onClick={onEditMode}
                >
                    <SvgIcon icon={EditMenuIcon} />
                    <span>{t('crm.deals.board.column.menu.edit')}</span>
                </DropdownMenuItem>
                <DropdownMenuItem
                    className="p-0 text-xs text-red-500 hover:bg-transparent focus:bg-transparent"
                    onClick={onDelete}
                >
                    <SvgIcon icon={DeleteMenuIcon} />
                    <span>{t('crm.deals.board.column.menu.delete')}</span>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
